import * as React from 'react'
import { View } from '../../../components/Themed'
import { colors } from '../../../components/DesignSystem'

export default function OrderSummarySeparator() {
	return (
		<View
			style={{
				height: 1,
				backgroundColor: colors.grayTranslucent,
				width: '100%',
				marginVertical: 16,
			}}
		/>
	)
}
